import VNConcessionsNavBar from '../components/VNConcessionsNavBar'
import GratuityHeader from '../components/GratuityHeader'
import { Box, Typography } from '@material-ui/core'
import { VNButtonContainer } from '../VNCustomerFacingDisplay/components/VNButtonContainer'
import styles from './Charity.module.scss'
import cn from 'classnames'
import VNBottomButton from '../components/VNBottomButton'
import { useEffect, useState } from 'react'
import { centsToDollars, centsToFixedDollars } from '../utils/formatters'
import { useDispatch, useSelector } from 'react-redux'
import {
  getCharityDescription,
  getCharityImage,
  getCharityName,
  getCharityOptions,
  getCharityOptionsEnabled,
  getRoundUpForCharityEnabled,
} from '../selectors/menus'
import { getNextDollar, transformCharityOptions } from '../utils/charityConfig'
import useGetIsMobileScreen from '../hooks/useGetIsMobileScreen'
import { setConnectionRequiredDialog, setVNTipEntryDialog } from '../VNDialogs/ActionCreators'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'
import {
  addDonationsToOrderInProgress,
  addPaymentToOrderInProgress,
  closeNoOpTender,
  orderDetailsRequested,
  removePaymentsFromOrderInProgress,
  selectOrder,
  updateSavedPayment,
} from '../actions/order'
import { getOrderInProgress } from '../selectors/order'
import { currentOrderUuid } from '../utils/orderNumbers'
import { PAYMENT_TYPES } from '../utils/paymentTypes'
import { isAuthFailedTab, isTabbed } from '../utils/orderStates'
import useCreateOrderInProgress from '../hooks/useCreateOrderInProgress'
import { ToastManager } from '../utils/toastManager'
import { isEmpty, findIndex } from 'lodash'
import { getVnTipEntryDialog } from '../VNDialogs/Selectors'
import { APPLICATION_STRINGS } from '../strings'
import { getNetworkAvailableValue } from '../utils/networkConnected'
import useSpinner from '../context/hooks/useSpinner'

export const Charity = ({ onDone, onBack = null, totalInCents, tipAmountInCents = 0 }) => {
  const classNames = cn(styles.charity)

  const charityOptions = useSelector(getCharityOptions)
  const charityTitle = useSelector(getCharityName)
  const charityDescription = useSelector(getCharityDescription)
  const optionsEnabled = useSelector(getCharityOptionsEnabled)
  const roundUpEnabled = useSelector(getRoundUpForCharityEnabled)
  const charityImage = useSelector(getCharityImage)
  const order = useSelector((state) => getOrderInProgress(state))
  const customTipEntryDialog = useSelector(getVnTipEntryDialog)
  const [charityOptionsEnabled, setCharityOptionsEnabled] = useState(false)

  const history = useHistory()
  const dispatch = useDispatch()
  const isTabOrder = isTabbed(order)
  const isMobile = useGetIsMobileScreen()
  const isTabAuthFailed = isAuthFailedTab(order)
  const networkAvailable = getNetworkAvailableValue()
  const [createOrder] = useCreateOrderInProgress()
  const { stopSpinner } = useSpinner()

  const fromCardLoader = history?.location?.state?.fromCardLoader || false
  const fromScanScreen = history?.location?.state?.fromScanScreen || false
  let total = fromCardLoader || fromScanScreen ? history?.location?.state?.totalInCents : totalInCents
  total = order?.reopened || order?.charityAmountInCents > 0 ? total - (order?.charityAmountInCents || 0) : total
  const redirectPath = history?.location?.state?.redirectPath ?? '/card-reader'
  const shouldRedirect = history?.location?.state?.shouldRedirect || true
  const closeWithSavedCard = history?.location?.state?.closeWithStoredCard || false
  const orderId = history?.location?.state?.orderId || null
  const paymentId = history?.location?.state?.paymentId || null

  //custom tender
  const maxAmountCustomTender = history?.location?.state?.maximumAmount
  const customTender = history?.location?.state?.customTender || null
  //states
  const [donations, setDonations] = useState([])
  const [donationId, setDonationId] = useState(null)
  const [donationAmount, setDonationAmount] = useState(0)
  const [defaultSelected, setDefaultSelected] = useState(false)
  const [userDonated, setUserDonated] = useState(false)

  useEffect(() => {
    if (isEmpty(charityOptions) && roundUpEnabled) {
      setCharityOptionsEnabled(false)
      return
    }

    setCharityOptionsEnabled(optionsEnabled)
    setDonations(transformCharityOptions(charityOptions))
  }, [charityOptions, roundUpEnabled, optionsEnabled])

  useEffect(() => {
    if (shouldRedirect && redirectPath !== '/card-reader' && !isTabOrder) {
      createOrder()
    }
    stopSpinner()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (order?.reopened && order?.previousCharityAmountInCents > 0 && optionsEnabled) {
      setDefaultSelected(true)
      const donationSelected = getDonationSelectedFromDonationAmount(order.previousCharityAmountInCents)

      setDonationId(donations[donationSelected]?.id || null)
      setDonationAmount(order.previousCharityAmountInCents || 0)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [order, donations])

  const getDonationSelectedFromDonationAmount = (donationAmount) => {
    let index = findIndex(donations, (donation) => donation.amount === donationAmount)

    if (index === -1) {
      index = findIndex(donations, (donation) => donation.isCustom && donationAmount > 0)
    }

    return index
  }

  // used for testing
  // const donations = [
  //   {
  //     title: '$1',
  //     price: 100,
  //   },
  //   {
  //     title: '$5',
  //     price: 500,
  //   },
  //   {
  //     title: '$10',
  //     price: 1000,
  //   },
  //   {
  //     price: null,
  //     isCustom: true,
  //     title: 'Custom'
  //   },
  // ]

  const goBack = () => {
    if (order.reopened && closeWithSavedCard) {
      dispatch(removePaymentsFromOrderInProgress())
    }

    if (onBack) {
      onBack()
      return
    }

    history.goBack()
  }

  const onButtonContainerClick = (button) => {
    if (userDonated) return
    const id = button?.id

    if (id === 'custom') {
      dispatch(
        setVNTipEntryDialog(
          true,
          (donationAmountInCents) => {
            setDonationAmount(donationAmountInCents)
            dispatch(setVNTipEntryDialog(false))
            setDonationId(id)
          },
          donationId === id ? donationAmount : 0,
          'Custom Donation',
          false,
          'Save',
        ),
      )
      return
    }

    setDonationId(id)
    const donationAmountInCents = donations.find((donation) => donation.id === id)?.amount || 0
    setDonationAmount(donationAmountInCents)
  }

  const displayFixedDonations = () => {
    let tipDisplayArray = [[]]

    if (isMobile) {
      tipDisplayArray = [[], []]
      donations.forEach((donation, index) => {
        if (index > 2) {
          tipDisplayArray[1].push({ ...donation, selected: donationId === donation.id })
          return
        }
        tipDisplayArray[0].push({ ...donation, selected: donationId === donation.id })
      })
    } else {
      donations.forEach((donation, index) => {
        tipDisplayArray[0].push({ ...donation, selected: donationId === donation.id })
      })
    }
    const hasCustom = donations.some((donation) => donation.isCustom)

    return (
      <Box className={styles.donationContainer}>
        <VNButtonContainer
          containerStyle={cn(styles.buttonContainer, { [styles.customDonation]: hasCustom })}
          buttonStyle={styles.containerButton}
          onClick={onButtonContainerClick}
          disabled={userDonated}
          defaultSelected={defaultSelected}
          buttons={tipDisplayArray}
        />
      </Box>
    )
  }

  const handleCustomTender = (amount) => {
    if (!customTender && !maxAmountCustomTender) {
      return
    }
    if (maxAmountCustomTender !== null && totalInCents + amount > maxAmountCustomTender) {
      createOrder()
      dispatch(
        addPaymentToOrderInProgress({
          tenderAmountInCents: total,
          paymentType: customTender?.name,
          shortDescription: customTender?.displayName,
          maximumAmount: maxAmountCustomTender,
          charityAmountInCents: amount,
          tipAmountInCents,
        }),
      )
      dispatch(addDonationsToOrderInProgress(amount))
      ToastManager.success(
        `${centsToFixedDollars(maxAmountCustomTender)} applied. ${centsToFixedDollars(total + amount - maxAmountCustomTender)} balance due.`,
        { autoClose: true },
      )
      history.push({
        pathname: '/tender-selection',
        state: {
          previousPaymentType: PAYMENT_TYPES.FIXED_CUSTOM_TENDER,
          tenderAmountInCents: total + amount - maxAmountCustomTender,
          fromSplit: true,
        },
      })
      return true
    }

    if (!isEmpty(customTender)) {
      if (isEmpty(order)) {
        dispatch(
          closeNoOpTender({
            orderUuid: isTabAuthFailed ? order?.uuid : currentOrderUuid(),
            tender: customTender,
            redirectOnSync: true,
            charityAmountInCents: amount,
            tipAmountInCents,
          }),
        )
        return true
      }
      dispatch(
        addPaymentToOrderInProgress({
          tenderAmountInCents: total,
          paymentType: customTender?.name,
          shortDescription: customTender?.displayName,
          maximumAmount: maxAmountCustomTender,
          charityAmountInCents: amount,
          tipAmountInCents,
        }),
      )
      return true
    }
  }

  const handleSavedCard = (amount) => {
    if (closeWithSavedCard) {
      dispatch(
        updateSavedPayment({
          charityAmountInCents: amount,
          tenderAmountInCents: total,
          tipAmountInCents,
        }),
      )
      return true
    }
  }

  const onConfirm = (donation = null) => {
    setUserDonated(true)

    if (order?.wasCreatedInStadium && !networkAvailable && isTabOrder) {
      dispatch(setConnectionRequiredDialog({ open: true, subtext: APPLICATION_STRINGS.INTERNET_CONNECTION_REQUIRED }))

      const orderUuid = order?.uuid || orderId
      dispatch(orderDetailsRequested(orderUuid))
      dispatch(selectOrder(orderUuid))

      history.push('/orders')
      return
    }

    let amount = donation ?? donationAmount

    if (roundUpEnabled && !charityOptionsEnabled && donation === null) {
      // if not null the user may have selected no thank you
      amount = getNextDollar(total)
    }

    let shouldReturn = handleCustomTender(amount)

    if (shouldReturn) return

    shouldReturn = handleSavedCard(amount)

    if (shouldReturn) return

    if (fromScanScreen && shouldRedirect) {
      dispatch(addDonationsToOrderInProgress(amount))
      history.push(redirectPath)
    }

    if (fromCardLoader && shouldRedirect) {
      history.push({
        pathname: redirectPath,
        state: {
          donationAmountInCents: amount,
          tenderAmountInCents: total,
          orderUuid: orderId,
          paymentId,
        },
      })
      return
    }

    if (onDone) {
      onDone(amount)
    }
  }

  const donationText = () => {
    if (isMobile && roundUpEnabled && !charityOptionsEnabled) {
      return `Round Up ${centsToFixedDollars(getNextDollar(total))}`
    }

    if (roundUpEnabled && !charityOptionsEnabled) {
      return `Round Up & Give ${centsToFixedDollars(getNextDollar(total))}`
    }

    return `Donate ${centsToFixedDollars(donationAmount)}`
  }

  const displaySecondaryText = () => {
    if (isMobile) {
      return charityOptionsEnabled ? 'Support a cause?' : 'Round up to support a cause?'
    }
    return `Total: ${centsToDollars(total + donationAmount)}`
  }

  return (
    <div className={classNames}>
      <div>
        <VNConcessionsNavBar textDisplay={isMobile && centsToDollars(total + donationAmount)} onClick={goBack} />
        <GratuityHeader
          primaryText={!isMobile && (charityOptionsEnabled ? 'Support a cause?' : 'Round up to support a cause?')}
          secondaryText={displaySecondaryText()}
          className={styles.gratuityHeader}
        />
      </div>
      <div className={styles.charityContainer}>
        {charityOptionsEnabled && displayFixedDonations()}
        <div className={cn(styles.centerColumn, { [styles.optionsEnabled]: charityOptionsEnabled })}>
          {charityImage && <img src={charityImage} alt="" className={styles.charityImage} />}
          {!charityImage && charityTitle && <Typography className={styles.charityText}>{charityTitle}</Typography>}
          {charityDescription && <Typography className={styles.charitySubtext}>{charityDescription}</Typography>}
        </div>
        {/* This is for checking if the keyboard is open */}
        {!customTipEntryDialog?.get('open') && (
          <div className={styles.bottomButtonContainer}>
            <VNBottomButton
              text={'No Thanks'}
              disabled={userDonated}
              onClick={() => onConfirm(0)}
              className={styles.noThanksButton}
            />
            <VNBottomButton
              text={donationText()}
              disabled={userDonated}
              onClick={() => onConfirm(null)}
              className={styles.donateButton}
            />
          </div>
        )}
      </div>
    </div>
  )
}
